var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tab"},[_vm._l((_vm.ARRAY),function(item,index){return _c('div',{key:index,ref:`tab${index}`,refInFor:true,staticClass:"tab-item",class:_vm.activeIndex === index ? 'active-tab-item' : '',on:{"click":function($event){return _vm.toActive(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),_c('div',{staticClass:"tab-line"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }